import type { GeometryPadWidgetConfig } from '../geometrypad.model';

export const SINGLE_RECTANGLE_PRESET: GeometryPadWidgetConfig = {
  id: 'single-rectangle',
  type: 'geometrypad',
  params: {
    elements: {
      r1: {
        type: 'Rectangle',
        params: { w: 8, h: 5 },
      },
    },
  },
  display: {
    geometry: {
      shape: { coloring: false },
      label: { coloring: true },
    },
  },
  behavior: {
    interactive: ['r1.point.A', 'r1.point.B', 'r1.point.D'],
  },
};
